__turbopack_context__.v({
  "beforeBox": "LatestNewsArticleCluster-module-scss-module__XULyQW__beforeBox",
  "firstArticle": "LatestNewsArticleCluster-module-scss-module__XULyQW__firstArticle",
  "lastArticle": "LatestNewsArticleCluster-module-scss-module__XULyQW__lastArticle",
  "latestNewsArticleContainer": "LatestNewsArticleCluster-module-scss-module__XULyQW__latestNewsArticleContainer",
  "separator": "LatestNewsArticleCluster-module-scss-module__XULyQW__separator",
});
